<template>
  <section class="closefriend-hero ">
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
    <influencer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></influencer-menu>
    <header-menu @slideMenu="slideBar()" :is-loading="isLoading"></header-menu>

    <div class="container-fluid mt-3">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <pwa-action-bar
            :show-subscribers="isNeedToAddExists"
            show-context
            context-icon="fa-cog"
            context-label="Options"
            @context-action="$router.replace({name: 'CustomRequestOptionList'})"
            :url="constructCustomerURL(user.urlSuffix)"
            @subscribers="goToNewSubscription()" />

          <div class="mx-auto mb-3 p-3 p-md-4">
            <global-message></global-message>
            
            <!-- Header with Manage Options Button -->
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-2">
              <h5 class="text-white font-weight-600 mb-0">Custom Requests</h5>
              <button type="button" class="cp-btn-ghost d-inline-flex align-items-center" @click="$router.push({name: 'CustomRequestOptionList'})">
                <i class="fa fa-cog me-2 font-size-12"></i> Request Options
              </button>
            </div>

            <div class="row">
              <div class="col-12 w-100">
                <!-- Loading Skeleton State -->
                <div v-if="isLoading" class="row mt-2">
                  <div class="col-12 col-md-6 col-lg-4 mb-4" v-for="i in 3" :key="i">
                    <div class="custom-card-transparent p-4 d-flex flex-column justify-content-between" style="min-height: 180px; animation: pulse 1.5s infinite;">
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <div style="width: 40px; height: 16px; background: rgba(255,255,255,0.08); border-radius: 4px;"></div>
                        <div style="width: 55px; height: 22px; background: rgba(255,255,255,0.08); border-radius: 4px;"></div>
                      </div>
                      <div style="height: 18px; width: 65%; background: rgba(255,255,255,0.08); border-radius: 4px; margin-bottom: 12px;"></div>
                      <div style="height: 14px; width: 90%; background: rgba(255,255,255,0.04); border-radius: 4px;"></div>
                      <div class="d-flex justify-content-between align-items-center mt-3 pt-3 border-top border-white-10">
                        <div style="height: 14px; width: 30%; background: rgba(255,255,255,0.06); border-radius: 4px;"></div>
                        <div style="height: 14px; width: 25%; background: rgba(255,255,255,0.06); border-radius: 4px;"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Empty State -->
                <div v-else-if="customRequests.length === 0" class="text-center py-5">
                  <div class="stella-empty-state-icon mb-3">
                    <img src="@/assets/images/stella/star.png" style="width: 56px; opacity: 0.4;">
                  </div>
                  <h5 class="text-white font-weight-500 mb-2" style="opacity: 0.6;">No custom requests yet</h5>
                  <p class="text-white font-size-14 mb-0" style="opacity: 0.35;">
                    Your followers can send you custom requests here.
                  </p>
                </div>

                <!-- Requests Cards -->
                <div v-else class="w-100 mt-2">
                  <!-- Filter UI -->
                  <div class="d-flex flex-wrap align-items-center mb-4">
                    <span 
                      class="badge filter-pill cursor-pointer me-2 mb-2" 
                      :class="selectedStatus === 'All' ? 'active' : ''"
                      @click="selectedStatus = 'All'">
                      All
                    </span>
                    <span 
                      v-for="status in uniqueStatuses" 
                      :key="status"
                      class="badge filter-pill cursor-pointer me-2 mb-2"
                      :class="selectedStatus === status ? 'active' : ''"
                      @click="selectedStatus = status">
                      {{ status }}
                    </span>
                  </div>

                  <div v-if="filteredRequests.length === 0" class="text-center py-5">
                    <p class="text-white font-size-14 mb-0" style="opacity: 0.5;">No custom requests found for status '{{ selectedStatus }}'</p>
                  </div>
                  <div v-else class="row">
                    <div class="col-12 col-md-6 col-lg-4 mb-3"
                         v-for="(customRequest, index) in filteredRequests" :key="index">
                    <div class="custom-card-transparent h-100 d-flex flex-column cursor-pointer" @click="statusAction(customRequest)" data-toggle="popover" data-placement="top" data-trigger="hover" :data-content="desc(customRequest)">
                      <div class="stella-card-header d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center" style="gap: 8px;">
                          <span class="stella-card-index">#{{ index + 1 }}</span>
                          <span class="font-size-11" style="color: rgba(255, 255, 255, 0.35);">• {{ customRequest.updatedAt | formatDateTime }}</span>
                          <img v-if="customRequest.favorite" src="@/assets/images/stella/stella-uploaded.png" style="width: 15px; height: 15px;">
                        </div>
                        <span class="stella-card-price">${{ customRequest.counterOfferPrice ? customRequest.counterOfferPrice : customRequest.offerPrice }}</span>
                      </div>
                      <div class="stella-card-body flex-grow-1">
                        <h6 class="stella-card-title">{{ customRequest.customer.name ? customRequest.customer.name : customRequest.customer.username }}</h6>
                        <p class="stella-card-desc mt-2 mb-0">{{ desc(customRequest) }}</p>
                      </div>
                      <div class="stella-card-footer d-flex align-items-center justify-content-between mt-auto">
                        <span class="stella-card-status" :style="'color: ' + getStatusColorHex(customRequest.status) + '; font-weight: 500;'">
                          <span class="status-dot" :style="'background-color: ' + getStatusColorHex(customRequest.status)"></span> 
                          {{ getStatus(customRequest.status) }}
                        </span>
                        <span class="stella-card-action d-inline-flex align-items-center font-weight-600" v-if="hasAction(customRequest.status)">
                          Take Action <i class="fa fa-arrow-right ms-1 font-size-11"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>

        <!--  Model for custom request counter  -->
        <model-influencer-custom-request-counter-offer
          ref="customRequestCounterOffer"
          @acceptedCustomRequest="(customRequest) => {
            $store.dispatch('setMessage', 'Custom request accepted successfully!');
            acceptedCustomRequest(customRequest);
          }"
          @declineCustomRequest="(customRequest) => {
            $refs.customRequestDecline.show(customRequest)
          }"
          @saveForLaterCustomRequest="(customRequest) => {
            $store.dispatch('setMessage', 'Custom request saved for later.');
            loadCustomRequest();
          }"
          @counterOffer="(customRequest) => {
            $refs.counterOfferSubmit.show(customRequest);
          }"
        />

        <model-influencer-custom-request-accepted
          ref="customRequestAcceptedDone"
          @customRequestAcceptedDone="() => {
              // loadCustomRequest();
          }"
        />

        <model-influencer-custom-request-decline
          ref="customRequestDecline"
          @declinedSuccess="() => {
            $store.dispatch('setMessage', 'Custom request declined successfully.');
            loadCustomRequest();
          }"/>

        <model-influencer-custom-request-counter-offer-submit
          ref="counterOfferSubmit" @counterOfferSubmitted="() => {
            $store.dispatch('setMessage', 'Counter offer submitted successfully.');
            $refs.counterOfferComplete.show();
            loadCustomRequest();
          }
        "/>

        <model-influencer-custom-request-counter-offer-complete
          ref="counterOfferComplete"/>

        <!--  Model for custom request content  -->
        <model-influencer-custom-request-upload-content
          ref="customRequestUploadContent"
          @customRequestUploaded="(customRequest, uploadData) => {
            $refs.customRequestUploadComplete.show(customRequest, uploadData)
          }"/>

        <model-influencer-custom-request-upload-complete
          ref="customRequestUploadComplete"
          @back="$refs.customRequestUploadContent.simpleShow()"
          @customRequestUploadCompleted="() => {
            $store.dispatch('setMessage', 'Custom request completed successfully!');
            $refs.customRequestUploadComplete.hide();
            loadCustomRequest();
          }"
        />

        <model-complete-custom-request-thank-you ref="customRequestUploadDone"/>
        <model-image-view ref="imageView"/>
        <model-video-view ref="videoView"/>
        <model-link ref="linkView"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import {mapGetters} from "vuex";

import {httpMixin} from "@/mixin/http-mixin";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import InfluencerHeader from "@/components/module/influencer/shared/InfluencerHeader";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import {newSubscriptionMixin} from "@/mixin/new-subscription-mixin";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import {
  CR_STATUS_ACCEPTED,
  CR_STATUS_COLOR,
  CR_STATUS_COUNTER,
  CR_STATUS_CUSTOMER_COUNTER,
  CR_STATUS_PENDING,
  CR_STATUS_READY,
  CR_STATUS_REVIEW,
  CR_STATUS_ACTION
} from "@/properties/custom-request-status";
import ModelInfluencerCustomRequestCounterOffer
  from "@/components/module/influencer/custom-request/ModelInfluencerCustomRequestCounterOffer";
import ModelInfluencerCustomRequestDecline
  from "@/components/module/influencer/custom-request/ModelInfluencerCustomRequestDecline";
import ModelInfluencerCustomRequestCounterOfferSubmit
  from "@/components/module/shared/custom-request/ModelCustomRequestCounterOfferSubmit";
import ModelInfluencerCustomRequestCounterOfferComplete
  from "@/components/module/shared/custom-request/ModelCustomRequestCounterOfferComplete";
import ModelInfluencerCustomRequestUploadContent
  from "@/components/module/influencer/custom-request/ModelInfluencerCustomRequestUploadContent";
import ModelInfluencerCustomRequestUploadComplete
  from "@/components/module/influencer/custom-request/ModelInfluencerCustomRequestUploadComplete";
import ModelCompleteCustomRequestThankYou
  from "@/components/module/influencer/custom-request/ModelCompleteCustomRequestThankYou";
import ModelInfluencerCustomRequestAccepted
  from "@/components/module/influencer/custom-request/ModelInfluencerCustomRequestAccepted";
import ModelImageView from "../../shared/ModelImageView";
import ModelVideoView from "../../shared/ModelVideoView";
import ModelLink from "../../customer/custom-request/ModelLink";
import {CR_STATUS_COMPLETED} from "../../../../properties/custom-request-status";
import {
  CONTENT_TYPE_APPLICATION,
  CONTENT_TYPE_IMAGE,
  CONTENT_TYPE_URL,
  CONTENT_TYPE_VIDEO
} from "../../../../properties/content-type";
import {constructCustomerURL} from "@/common/baseURL-service";
import {customRequestDesc} from "@/common/comm-service";
import titleMixin from "../../../../mixin/title-mixin";
import PwaActionBar from "@/components/module/influencer/shared/PwaActionBar";

export default {
  name: 'CustomRequestList',
  title: 'Creator custom requests',
  mixins: [httpMixin, newSubscriptionMixin, titleMixin],
  components: {
    HeaderMenu, InfluencerMenu,
    InfluencerHeader, GlobalMessage,
    PwaActionBar,
    ModelInfluencerCustomRequestCounterOffer,
    ModelInfluencerCustomRequestDecline,
    ModelInfluencerCustomRequestCounterOfferSubmit,
    ModelInfluencerCustomRequestCounterOfferComplete,
    ModelInfluencerCustomRequestUploadContent,
    ModelInfluencerCustomRequestUploadComplete,
    ModelCompleteCustomRequestThankYou,
    ModelInfluencerCustomRequestAccepted, ModelImageView,
    ModelVideoView, ModelLink
  },
  data() {
    return {
      isLoading: true,
      user: [],
      customRequests: [],
      selectedStatus: 'All',
      showSlideBar: false,
      CR_STATUS_COLOR,

      pageNumber: 0,
      noOfItems: 999,
    }
  },
  created() {
    this.user = this.getUser();
    this.loadCustomRequest();
    this.checkNewSubscription(this.user.id);
  },
  computed: {
    copyLabel() {
      return this.copied ? 'Copied' : 'Copy';
    },
    uniqueStatuses() {
      const statuses = new Set();
      this.customRequests.forEach(req => {
        statuses.add(this.getStatus(req.status));
      });
      return Array.from(statuses).sort();
    },
    filteredRequests() {
      if (!this.selectedStatus || this.selectedStatus === 'All') {
        return this.customRequests;
      }
      return this.customRequests.filter(req => this.getStatus(req.status) === this.selectedStatus);
    }
  },
  methods: {
    ...mapGetters(['getUser']),
    constructCustomerURL,
    statusAction(customRequest) {

      if (customRequest.status === CR_STATUS_REVIEW ||
        customRequest.status === CR_STATUS_CUSTOMER_COUNTER ) {
        this.$refs.customRequestCounterOffer.show(customRequest);
      } else if (customRequest.status === CR_STATUS_READY) {
        this.$refs.customRequestUploadContent.show(customRequest);
      } else if (customRequest.status === CR_STATUS_COMPLETED) {
        let content = customRequest.content;

        if (content.type === CONTENT_TYPE_IMAGE && content.cdnUrl) {
          this.$refs.imageView.show(content.cdnUrl);
        } else if (content.type === CONTENT_TYPE_VIDEO && content.cdnUrl) {
          this.$refs.videoView.show(content.cdnUrl);
        } else if (content.type === CONTENT_TYPE_URL || content.type === CONTENT_TYPE_APPLICATION) {
          this.$refs.linkView.show(content);
        }
      }
    },
    acceptedCustomRequest(customRequest) {
      this.$refs.customRequestCounterOffer.hide();
      this.loadCustomRequest();
      if (customRequest.status === CR_STATUS_READY) {
        this.$refs.customRequestUploadContent.show(customRequest);
      } else {
        this.$refs.customRequestAcceptedDone.show();
      }
    },
    loadCustomRequest() {
      this.isLoading = true;
      // /api/v1/influencers/{influncerId}/custom-request/
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/custom-request/page?pageNumber=${this.pageNumber}&numberOfItems=${this.noOfItems}`;
      this.getData(url, (page) => {
        this.customRequests.splice(0);
        this.customRequests.push(...page.content);
        this.$nextTick(() => {
          $('[data-toggle="popover"]').popover();
        });
      })
    },
    desc: customRequestDesc,
    getStatus(status) {
      if (status === CR_STATUS_COUNTER) {
        return CR_STATUS_PENDING;
      } else if (status === CR_STATUS_ACCEPTED) {
        return CR_STATUS_PENDING;
      } else if (status === CR_STATUS_CUSTOMER_COUNTER) {
        return CR_STATUS_REVIEW;
      } else {
        return status;
      }
    },
    hasAction(status) {
      return status === CR_STATUS_REVIEW ||
             status === CR_STATUS_READY;
    },
    getStatusColorHex(status) {
      const s = status === CR_STATUS_ACTION ? CR_STATUS_REVIEW : status;
      if (s === 'Review' || s === CR_STATUS_REVIEW || s === 'Counter' || s === 'CustomerCounter') return '#F1C40F'; // Warning (Amber)
      if (s === 'Ready' || s === 'Completed' || s === CR_STATUS_READY || s === 'Completed') return '#55EFC4'; // Success (Emerald)
      if (s === 'Pending' || s === CR_STATUS_PENDING) return '#80CBFE'; // Info (Blue)
      if (s === 'Declined' || s === 'Canceled' || s === 'Expired') return '#FF4B81'; // Danger (Red)
      return '#B8B8B8'; // Default (Gray)
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    }
  }
}
;
</script>



<style scoped>
.filter-pill {
  background-color: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 13px;
  transition: all 0.2s ease;
}
.filter-pill:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.filter-pill.active {
  background-color: #E53BB9; /* Primary pink/purple color */
  color: #fff;
  border-color: transparent;
}
.cursor-pointer {
  cursor: pointer;
}
.closefriend-hero {
  background-color: #111111 !important;
  background-image: none !important;
  min-height: 100vh;
}
.container-fluid, .row, .col-12 {
  background-color: transparent !important;
  background-image: none !important;
}


.stella-card-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
